import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'

@Injectable()
export class ClassWatcherService {

  public watchClass(element: HTMLElement, className: string): Observable<boolean> {
    return new Observable(observer => {
      const mutationObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            const hasClass = (mutation.target as HTMLElement).classList.contains(className)
            observer.next(hasClass)
          }
        })
      })

      mutationObserver.observe(element, {attributes: true})

      return () => mutationObserver.disconnect()
    })
  }

}
